<template>
  <section class="-mt-4 px-5 overflow-x-hidden">
    <template v-if="isBankDetails">
      <p class="text-xs font-light pb-1 border-b">RECIPIENT BANK DETAILS</p>
      <ul class="font-light text-xs lg:text-sm">
        <li v-for="(details, index) in bankDetails" :key="index">
          <div
            v-if="details.value"
            class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
          >
            <span>{{ details.label }}</span>
            <div class="capitalize">
              <span>{{ details.value }}</span>
              <span
                v-if="details.copyIcon"
                class="cursor-pointer mb-1 ml-2"
                v-clipboard:copy="details.value"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <copy-icon />
              </span>
            </div>
          </div>
        </li>
      </ul>
    </template>
    <template v-if="displayPersonalDetails">
      <p class="text-xs font-light pb-1 border-b mt-10">RECIPIENT DETAILS</p>
      <ul class="font-light text-xs lg:text-sm">
        <li v-for="(details, index) in personalDetails" :key="index">
          <div
            v-if="details.value"
            class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
          >
            <span>{{ details.label }}</span>
            <span>{{ details.value }}</span>
          </div>
        </li>
      </ul>
    </template>
    <template v-if="displayWalletDetails">
      <p class="text-xs font-light pb-1 border-b mt-10">WALLET DETAILS</p>
      <ul class="font-light text-xs lg:text-sm">
        <li v-for="(detail, index) in walletDetails" :key="index">
          <div
            class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
            v-if="detail.value"
          >
            <span>{{ detail.label }}</span>
            <span>
              {{ detail.value }}
              <span
                v-if="detail.copyIcon"
                class="cursor-pointer mb-1 ml-2"
                v-clipboard:copy="detail.copyValue"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <copy-icon />
              </span>
            </span>
          </div>
        </li>
      </ul>
    </template>
    <!-- mobile money details -->
    <template v-if="isMobileMoneyDetails">
      <p class="text-xs font-light pb-1 border-b mt-10">
        RECIPIENT MOBILE MONEY DETAILS
      </p>
      <ul class="font-light text-xs lg:text-sm">
        <li
          v-for="(details, index) in mobileMoneyDetails"
          :key="index"
          class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
        >
          <span v-if="details.value">{{ details.label }}</span>
          <span class="capitalize" v-if="details.value"
            >{{ details.value }}
          </span>
        </li>
      </ul>
    </template>
    <!-- <div
      class="mt-5 bg-blue-100 rounded-lg shadow-xs px-4 lg:px-8 py-4 flex items-center justify-center gap-x-2 cursor-pointer transition-all duration-300 ease hover:opacity-80"
    >
      <profile-icon-plus />
      <span class="font-medium text-primary text-xs lg:text-sm"
        >Save Beneficiary</span
      >
    </div> -->
  </section>
</template>

<script>
import { MaskWalletAddressTwo, ParseNetworkName } from '@/utils/helpers.js'
export default {
  props: {
    transactionDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
    // ProfileIconPlus: () => import('@/assets/v2/icons/ProfileIconPlus.vue')
  },
  computed: {
    displayPersonalDetails () {
      return this.transactionInfo?.transferDestination?.personalDetails || ''
    },
    displayWalletDetails () {
      return this.transactionInfo?.transferDestination?.walletDetails || ''
    },
    walletDetails () {
      const details = this.transactionInfo?.transferDestination?.walletDetails
      return [
        { label: 'Asset Type', value: details.assetType || '-' },
        { label: 'Network', value: this.parseNetworkName(details.network) },
        {
          label: 'Wallet Address',
          value: this.maskID(details.walletAddress),
          copyValue: details.walletAddress,
          copyIcon: true
        }
      ]
    },
    personalDetails () {
      const details = this.transactionInfo?.transferDestination?.personalDetails
      return [
        { label: 'Country', value: details?.country },
        { label: 'City', value: details?.city },
        {
          label: 'Address',
          value: details?.address
        },
        { label: 'Name', value: details?.name },
        { label: 'District', value: details?.district }
      ]
    },
    bankDetails () {
      const details = this.transactionInfo?.transferDestination?.bankDetails
      return [
        { label: 'Country', value: details?.country },
        { label: 'Bank Name', value: details?.bankName },
        { label: 'Account No', value: details?.accountNumber, copyIcon: true },
        { label: 'Account Name', value: details?.accountName },
        { label: 'Bank Branch', value: details?.bankBranch },
        { label: 'Swift Code', value: details?.swiftCode },
        { label: 'Routing Number', value: details?.routingNo }
      ]
    },
    transactionInfo () {
      return this.$store.state.transactions.transactionDetails
    },
    isMobileMoneyDetails () {
      return (
        this.transactionInfo.transferDestination?.bankDetails?.isMobileMoney ===
        'yes'
      )
    },
    isBankDetails () {
      return (
        !this.isMobileMoneyDetails &&
        this.transactionInfo.transferDestination?.bankDetails
      )
    },
    mobileMoneyDetails () {
      return [
        {
          label: 'Account Name',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.accountName
        },
        {
          label: 'Phone Number',
          value:
            this.transactionInfo?.transferDestination?.bankDetails
              ?.accountNumber
        },
        {
          label: 'Mobile Money Provider',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.bankName
        },
        {
          label: 'Provider Code',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.bankCode
        }
      ]
    }
  },
  methods: {
    changePage () {
      this.$emit('changePage', 'first-page')
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    parseNetworkName (name) {
      return ParseNetworkName(name)
    }
  }
}
</script>
